import React from 'react'
import PropTypes from 'prop-types'
import { graphql, StaticQuery } from 'gatsby'
import styled from 'styled-components'
import BackgroundImage from 'gatsby-background-image'

const StyledBackgroundImage = styled(BackgroundImage)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-position: 0% 60%;
  width: 100%;
  height: 100vh;

  @media (min-width:768px) and (max-width:1023px) {
    height: 400px;
  }
`

const FullHeaderImageBg = ({ children, imageData, className }) => (
  <StaticQuery 
    query={query}
    render={
      data => {
        const imageDataDefault = data.imageBg.childImageSharp.fluid

        return (
          <StyledBackgroundImage
            className="relative"
            fluid={ imageData ? imageData : imageDataDefault }
            backgroundColor={`#040e18`}
          >
            {children}
          </StyledBackgroundImage>
        )
      }
    }
  />
)

FullHeaderImageBg.propTypes = {
  children: PropTypes.node,
  imageData: PropTypes.object,
  className: PropTypes.string,
}

export default FullHeaderImageBg

const query = graphql`
  query FullHeaderImageBgQuery {
    imageBg: file(relativePath: { eq: "header/home-header-bg-1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1900) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`